import React from 'react';
import { useTranslation } from 'react-i18next';
import { TabsContainer, Tab } from './Tabs.style';
import { FilterOption } from '../../../types';

interface TabsProps {
  options: {
    [key: string]: FilterOption;
  };
  selectedOption: string;
  onChange: (newValue: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ options, selectedOption, onChange }) => {
  const { t } = useTranslation();
  const handleSelectTab = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <>
      <TabsContainer>
        {Object.keys(options).map((value, index) => {
          const { label } = options[value];
          return (
            <Tab
              isSelected={value === selectedOption}
              key={`tab-value-${value}`}
              onClick={() => handleSelectTab(value)}
            >
              {label}
            </Tab>
          );
        })}
      </TabsContainer>
    </>
  );
};

export default Tabs;
